exports.IDS = {
  // IMG_URL: "http://127.0.0.1:8899",
  IMG_URL: "https://node.chakriking.com",
  // IMG_URL: "https://chakrikingnode.profcymadev.com:8899",

  PAGE: 1,
  PERPAGE: 10,
  TOTALPAGES: 1,
  TOTAL: 1,
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  BLOCK: "BLOCKED",
  UNBLOCK: "UNBLOCKED",
  SLICESTATUS: {
    Idle: "idle",
    Loading: "loading",
    Succeeded: "succeeded",
    Failed: "failed",
  },

  Admin: 1,
  Roles: {
    Admin: 1,
    SuperSuperMaster: 2,
    SuperMaster: 3,
    Master: 4,
    Client: 5,
  },
};
